import { UserRoleBadgeContainer } from "./UserRoleBadge.styles";

export function UserRoleBadge({
    text,
    backgroundColor,
    color,
}: {
    text: string;
    backgroundColor: string;
    color: string;
}) {
    return (
        <UserRoleBadgeContainer
            sx={{ backgroundColor: backgroundColor, color: color }}
        >
            {text}
        </UserRoleBadgeContainer>
    );
}
